export const productIcons = [
    {
        icon: "asset-and-investment-management",
        name: "Asset & Investment Management",
    },
    {
        icon: "asset-optimization",
        name: "Asset Optimization",
    },
    {
        icon: "amenity-analysis",
        name: "Amenity Analysis",
    },
    {
        icon: "axiometrics",
        name: "Axiometrics",
    },
    {
        icon: "business-intelligence",
        name: "Business Intelligence",
    },
    {
        icon: "data-analytics",
        name: "Data Analytics",
    },
    {
        icon: "deposit-iq",
        name: "Deposit IQ",
    },
    {
        icon: "easy-lms",
        name: "Easy LMS",
    },
    {
        icon: "get-work",
        name: "Get Work",
    },
    {
        icon: "ilm-leasing-analytics",
        name: "ILM Leasing Analytics",
    },
    {
        icon: "intelligent-lead-management",
        name: "ILM",
    },
    {
        icon: "investment-analytics",
        name: "Investment Analytics",
    },
    {
        icon: "kigo",
        name: "Kigo",
    },
    {
        icon: "lead-analytics",
        name: "Lead Analytics",
    },
    {
        icon: "lead2lease",
        name: "Lead 2 Lease",
    },
    {
        icon: "lease-management",
        name: "Lease Managment",
    },
    {
        icon: "lro",
        name: "LRO",
    },
    {
        icon: "market-comps",
        name: "Market Comps",
    },
    {
        icon: "marketing-center",
        name: "Marketing Center",
    },
    {
        icon: "omnichannel",
        name: "Omni Channel",
    },
    {
        icon: "on-site",
        name: "On-Site",
    },
    {
        icon: "onesite-screening",
        name: "OneSite Screening",
    },
    {
        icon: "onesite",
        name: "OneSite",
    },
    {
        icon: "online-leasing",
        name: "Online Leasing",
    },
    {
        icon: "payments",
        name: "Payments",
    },
    {
        icon: "performance-analytics",
        name: "Performance Analytics",
    },
    {
        icon: "portfolio-asset-management",
        name: "Portfolio Asset Management",
    },
    {
        icon: "property-photos",
        name: "Property Photos",
    },
    {
        icon: "propertyware",
        name: "Propertyware",
    },
    {
        icon: "prospect-contact-center",
        name: "Prospect Contact Center",
    },
    {
        icon: "realpage-accounting",
        name: "RealPage Accounting",
    },
    {
        icon: "realpage-document-management",
        name: "RealPage Document Management",
    },
    {
        icon: "realpage-portfolio-management",
        name: "RealPage Portfolio Management",
    },
    {
        icon: "relate-24-7",
        name: "Relate 24/7",
    },
    {
        icon: "renters-insurance",
        name: "Renters Insurance",
    },
    {
        icon: "rentjoy",
        name: "RentJoy",
    },
    {
        icon: "rentjoy-crm",
        name: "RentJoy CRM",
    },
    {
        icon: "resident-portals",
        name: "Resident Portals",
    },
    {
        icon: "resident-services",
        name: "Resident Services",
    },
    {
        icon: "revenue-forecaster",
        name: "Revenue Forecaster",
    },
    {
        icon: "revenue-management",
        name: "Revenue Management",
    },
    {
        icon: "spend-management",
        name: "Spend Management",
    },
    {
        icon: "underwriting-analytics",
        name: "Underwriting Analytics",
    },
    {
        icon: "unified-amenities",
        name: "Unified Amenities",
    },
    {
        icon: "utility-management",
        name: "Utility Management",
    },
    {
        icon: "vendor-marketplace",
        name: "Vendor Marketplace",
    },
    {
        icon: "vendor-services",
        name: "Vendor Services",
    },
    {
        icon: "windsor-consulting",
        name: "Windsor Consulting",
    },
    {
        icon: "yieldstar",
        name: "Yieldstar",
    },
];
//# sourceMappingURL=productIconList.js.map
